<template>
  <BaseDialog :is-open="isOpen" @close="emit('close')">
    <form
      novalidate
      class="flex flex-col gap-4 px-2 py-4"
      @submit="onFormSubmit"
    >
      <FormInputText name="sms" label="Phone Number" />
      <FormSubmitButton :is-submitting="isSubmitting"
        >Send Receipt</FormSubmitButton
      >
    </form>
  </BaseDialog>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { ApiError } from "@/api"
import { requiredTrimmedString } from "@/validation/sharedStringFieldSchemas"

const props = defineProps<{
  isOpen: boolean
  orderId?: string
  donationId?: string
  transactionId?: string
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const formSchema = z.object({
  sms: requiredTrimmedString("Please enter a phone number"),
})

const { handleSubmit, isSubmitting, setFieldError } =
  useForm({
    validationSchema: toTypedSchema(formSchema),
    initialValues: { sms: "" },
  })

const onFormSubmit = handleSubmit(async (formValues) => {
  try {
    if (props.orderId) {
      await sendOrderReceipt(props.orderId, formValues)
    } else if (props.donationId) {
      await sendDonationReceipt(
        props.donationId,
        formValues
      )
    } else if (props.transactionId) {
      await sendTransactionReceipt(
        props.transactionId,
        formValues
      )
    }
    toast.success(`Receipt sent to ${formValues.sms}`)
    emit("close")
  } catch (error) {
    if (error instanceof ApiError) {
      const smsValidationError =
        error?.requestErrors?.body?.sms

      if (smsValidationError) {
        setFieldError("sms", smsValidationError)
        return
      }
      if (error.code === "sms-service-disabled") {
        toast.error("SMS service is disabled")
      } else {
        toast.error("Failed to send receipt")
      }
    } else {
      toast.error("Failed to send receipt")
    }
  }
})
</script>
